export {
  TextBase as Text,
  type TextBaseProps as TextProps,
} from './text-base.tsx'
export * from './truncated-text.tsx'
